<template>
  <div>
    <div class="voucher__col">
      <h2 class="voucher__col-title">
        {{$t('vouchers.chooseTitle')}}
      </h2>
      <p>  {{$t('vouchers.instrText')}}</p>
      <div class="voucher-list">
        <div class="row" v-for="voucher in vouchers" :key="voucher.id">
          <div class="voucher-list__item">
            <h3>{{ voucher.title }}</h3>

            <div class="voucher__info">
              {{ voucher.description }}
              <div>CHF {{ voucher.price }} / {{$t('vouchers.pcs')}}</div>
            </div>
          </div>
          <div class="plus-minus">
            <button @click.prevent="onVoucherSub(voucher)">
              <SVGMinus />
            </button>
            <div class="plus-minus__counter">
              {{voucher.quantity}}
            </div>
            <button @click.prevent="onVoucherAdd(voucher)">
              <SVGPlus />
            </button>
          </div>
          <input
            :name="`voucher[${voucher.id}]`"
            type="hidden"
            v-model.number="voucher.quantity"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      maxQuantity: 99,
    }
  },
  computed: {
    vouchers() {
      return this.$root.$data.shared.vouchers;
    }
  },
  methods: {
    onVoucherSub (voucher) {
      if (voucher.quantity > 0) {
        voucher.quantity--
      }
    },
    onVoucherAdd (voucher) {
      if (voucher.quantity < this.maxQuantity) {
        voucher.quantity++
      }
    }
  }
};
</script>

<style></style>
